import React from "react";
import "./DashboardScopeToggle.scss";

export default function DashboardScopeToggle({ value, onChange }) {
  return (
    <div className="dashboard-scope-toggle" role="group" aria-label="Dashboard scope">
      {[["my", "My work"], ["firm", "Firm overview"]].map(([scope, label]) => (
        <button
          key={scope}
          type="button"
          aria-pressed={value === scope}
          onClick={() => { if (scope !== value) onChange(scope); }}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
